/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SHOWMODAL } from '../../../actions/constantsActions';
import { FacebookLogin } from '../../../utils/FacebookLogin';
import { converter } from '../../../helpers/converter';

export class FbAccountAttach extends React.Component {
  onFacebookResponse = data => {
    this.props.onAttachFacebook(data);
  };

  render() {
    const { region } = this.props.user;
    const locale = region === 'brasil' ? 'pt_BR' : 'es_ES';

    return (
      <div id="social_estado">
        <div className="col-lg-7 col-md-7 col-sm-8 col-xs-12 padding-top-05">
          <p
            dangerouslySetInnerHTML={{
              __html: converter.convertApaUnicode(
                this.props.translations,
                'profile_social_fb_attach',
                'Vincula tu cuenta <b>Claro video</b> con Facebook. Comenta, recomienda y comparte los mejores contenidos con tus amigos.',
              ),
            }}
          />
        </div>
        <div className="col-lg-3 col-md-3">
          <span
            id="cargando"
            className="full-width padding-2"
            style={{ display: 'none' }}
          >
            <img
              alt=""
              width="54"
              className="center-block"
              src="https://clarovideocdn0.clarovideo.net/fe/sitesplus/sk_core/images/cargando.gif"
            />
          </span>
        </div>
        <div className="col-lg-2 col-md-2 col-sm-4 col-xs-12 padding-top-1">
          <FacebookLogin
            socialId="407287369327882"
            language={locale}
            scope="public_profile, email"
            fields="id, email, cover, name, first_name, last_name, age_range, link, gender, locale, picture, timezone, updated_time, verified"
            responseHandler={this.onFacebookResponse}
            xfbml
            version="v2.5"
            class="btn btn-fb btn-default btn-block margin-05"
            buttonText={converter.convertApaUnicode(
              this.props.translations,
              'profile_social_network_button_link_attach',
              'Vincular',
            )}
          />
        </div>
      </div>
    );
  }
}

FbAccountAttach.propTypes = {
  onAttachFacebook: PropTypes.func,
  translations: PropTypes.shape({}),
  user: PropTypes.shape({
    region: PropTypes.string,
  }),
};

const mapStateToProps = state => ({
  translations: state.translations,
  config: state.config,
  user: state.user,
});

const showModal = modal => ({
  type: SHOWMODAL,
  modal,
});

export default connect(
  mapStateToProps,
  { showModal },
)(FbAccountAttach);
